import $ from 'jquery';
import get from 'lodash/get';

export default function(){
  const openFilter = get(window, 'rcProps.trigger.hp.openAppRestriction', false);
  const $appPromoBanner = $('.js-app-promo-banner');
  if (openFilter) {
    $appPromoBanner[0].scrollIntoView();
    $appPromoBanner.find('.js-modal').click();
  }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/homepage/amp-app-promo.js